// client/data/projects.js
export const projects = [
  {
    title: "Blockchain Task Manager",
    description: "A decentralized task manager built on the Ethereum blockchain, ensuring secure, transparent, and immutable task tracking.",
    githubLink: "https://github.com/Krishna-R-Sonar/blockchain-Task-Manager-tech",
    deployedLink: "https://task-manager-nine-self.vercel.app"
  },
  {
    title: "CampusNotes",
    description: "Share and acquire study materials with your campus community",
    githubLink: "https://github.com/Krishna-R-Sonar/campusnotes-react-frontend/tree/master",
    deployedLink: "https://campusnotes-react-frontend.vercel.app"
  },
  {
    title: "TalentTrack",
    description: "Job portal website",
    githubLink: "https://github.com/Krishna-R-Sonar/TalentTrack",
  },
  {
    title: "AccessAI",
    description: "Leveraging Gemini AI API to provide better solutions to prompts",
    githubLink: "https://github.com/Krishna-R-Sonar/AccessAI",
    deployedLink: "https://accessai-five.vercel.app/"
  }
];
